import ErrorMessage from '@components/ErrorBoundary/ErrorMessage'
import Loader from '@components/Loader/Loader'
import { Suspense } from 'react'
import ErrorBoundary from '@components/ErrorBoundary/ErrorBoundary'
import TableData from './TableData/TableData'

import './DataSetInfo.css'

export default function DataSetInfo() {
  return (
    <div id="dataset-info" className="page">
      <ErrorBoundary errorComponent={ErrorMessage}>
        <Suspense fallback={<Loader />}>
          <TableData />
        </Suspense>
      </ErrorBoundary>
    </div>
  )
}
